import toast from 'react-hot-toast';

export const numberWithSpaces = (x) => {
    if (typeof x === 'number') return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return '';
};

export const isFloat = (n) => {
    return Number(n) === n && n % 1 !== 0;
};

export const slugify = (str) =>
    str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');

export const isNextendActivated = () => {
    const element = document.getElementById('data-nextend');
    return element?.dataset.nextendActivated === '1';
};

export const isProviderActivated = (provider) => {
    const element = document.getElementById('data-nextend-providers');
    return element?.dataset[provider] === '1';
};

export const copyToClipboard = (code, message = 'Code copié') => {
    navigator.clipboard.writeText(code);
    toast.success(message);
};

export const convertTwitterMessage = (message, code, shareLink) => {
    return message.replace('{code}', code).replace('{lien}', shareLink);
};

export const timerQuiz = (expiration) => {
    if (expiration === null || expiration === undefined) {
        return <></>;
    }

    const now = new Date();
    const expiryDate = new Date(expiration);
    const hoursUntilExpiration = (expiryDate - now) / (1000 * 60 * 60);

    if (hoursUntilExpiration < 0) {
        return <>⏰ Terminé</>;
    } else {
        // Plus que hh:mm
        const days = Math.floor(hoursUntilExpiration / 24);
        const hours = Math.floor(hoursUntilExpiration % 24);
        const minutes = Math.floor((hoursUntilExpiration % 1) * 60);
        return (
            <>
                ⏱️ Plus que{' '}
                <span>
                    {days.toString().padStart(2, '0')}j {hours.toString().padStart(2, '0')}h{' '}
                    {minutes.toString().padStart(2, '0')}m
                </span>
            </>
        );
    }
};
